// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Export schedule types for recurring report generation.
 * Sprint 3.6.0 - Epic 5: Export & Report Scheduling
 *
 * Sprint 63.30.0 (#584, owner ruling Q2, decision E3) — schedules are executed.
 * A sweep claims every due schedule, produces the file through
 * `UnifiedExportService` under the schedule creator's own grants, records the
 * run `completed` (with the file) or `failed` (with a reason), retries a failed
 * run at most {@link EXPORT_RUN_MAX_RETRIES} times and e-mails the recipients a
 * link. `custom` is withdrawn: it was never defined, so no loader can produce it.
 */
import { Permission } from '../constants/permissions.js';
/**
 * The export types a schedule can produce — each has a loader on the server.
 * `custom` is gone (Sprint 63.30.0, Q2): it named no content.
 */
export const SCHEDULED_EXPORT_TYPES = [
    'ropa',
    'audit_trail',
    'compliance_report',
    'incident_report',
];
/**
 * A type a schedule may still HOLD from before the withdrawal. Read-only: the
 * create and update routes refuse it, and the startup migration pauses every
 * schedule that holds it, with a reason.
 */
export const WITHDRAWN_EXPORT_TYPES = ['custom'];
/**
 * `(export type) → the permission the run's actor must hold`, and the grant a
 * reader must hold to retrieve the file a run produced (the 64.92.0 kinded-export
 * contract: retrieval honours the creation grant, resolved per kind).
 *
 * Each is the grant of the same content's on-demand export elsewhere in the
 * product: the data-mapping export route, the unified audit export, the incident
 * exports, and the framework register read (the compliance report reproduces the
 * dashboard's framework coverage, which is read under it).
 */
export const SCHEDULED_EXPORT_GATES = {
    ropa: Permission.DM_EXPORT_PDF,
    audit_trail: Permission.AUDIT_EVENTS_EXPORT,
    compliance_report: Permission.REGULATORY_FRAMEWORK_READ,
    incident_report: Permission.INCIDENT_EXPORT_EXECUTE,
};
/** The attachment owner type every run's file is stored under (kinded by export type). */
export const SCHEDULED_EXPORT_RUN_OWNER_TYPE = 'scheduled_export_run';
/** A failed run is executed again at most this many times, on later ticks. */
export const EXPORT_RUN_MAX_RETRIES = 3;
//# sourceMappingURL=export-schedule.js.map